import React from 'react'

import { NavBar, Drawer } from 'components'

import { useStyles } from './styles'

const Layout: React.FC = ({ children }) => {
  const classes = useStyles()
  const [isDrawerExpanded, setIsDrawerExpanded] = React.useState(false)

  const handleDrawerExpand = (expanded: boolean) => {
    setIsDrawerExpanded(expanded)
  }

  return (
    <div className={classes.root}>
      <NavBar isLoggedIn />
      <Drawer onExpandChange={handleDrawerExpand} />
      <main className={`${classes.content} ${!isDrawerExpanded ? classes.contentShift : ''}`}>
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  )
}

export { Layout }
